import type { LanguageData } from "./types";

// 既存
import { languageData as python } from "./lang-python";
import { languageData as javascript } from "./lang-javascript";
import { languageData as typescript } from "./lang-typescript";
import { languageData as htmlCss } from "./lang-html-css";
import { languageData as react } from "./lang-react";
import { languageData as sql } from "./lang-sql";
import { languageData as git } from "./lang-git";
import { languageData as aiMl } from "./lang-ai-ml";

// 新規追加
import { languageData as java } from "./lang-java";
import { languageData as restApi } from "./lang-rest-api";
import { languageData as uiUx } from "./lang-ui-ux";
import { languageData as linux } from "./lang-linux";
import { languageData as aws } from "./lang-aws";
import { languageData as docker } from "./lang-docker";
import { languageData as awsSaa } from "./lang-aws-saa";
import { languageData as generativeAi } from "./lang-generative-ai";
import { languageData as ragLlm } from "./lang-rag-llm";
import { languageData as nocodeAi } from "./lang-nocode-ai";
import { languageData as kubernetes } from "./lang-kubernetes";
import { languageData as terraform } from "./lang-terraform";
import { languageData as security } from "./lang-security";
import { languageData as systemDesign } from "./lang-system-design";
import { languageData as componentDesign } from "./lang-component-design";
import { languageData as stateManagement } from "./lang-state-management";
import { languageData as dataVisualization } from "./lang-data-visualization";
import { languageData as promptEngineering } from "./lang-prompt-engineering";
import { languageData as csBasics } from "./lang-cs-basics";
import { languageData as dxLiteracy } from "./lang-dx-literacy";
import { languageData as teamDev } from "./lang-team-dev";
import { languageData as mlDl } from "./lang-ml-dl";
import { languageData as upstream } from "./lang-upstream";

export type { LanguageData } from "./types";

/** slug → LanguageData のマップ */
export const languages: Record<string, LanguageData> = {
  python,
  javascript,
  typescript,
  "html-css": htmlCss,
  react,
  sql,
  git,
  "ai-ml": aiMl,
  java,
  "rest-api": restApi,
  "ui-ux": uiUx,
  linux,
  aws,
  docker,
  "aws-saa": awsSaa,
  "generative-ai": generativeAi,
  "rag-llm": ragLlm,
  "nocode-ai": nocodeAi,
  kubernetes,
  terraform,
  security,
  "system-design": systemDesign,
  "component-design": componentDesign,
  "state-management": stateManagement,
  "data-visualization": dataVisualization,
  "prompt-engineering": promptEngineering,
  "cs-basics": csBasics,
  "dx-literacy": dxLiteracy,
  "team-dev": teamDev,
  "ml-dl": mlDl,
  upstream,
};

/** 全言語スラッグの配列 */
export const languageSlugs = Object.keys(languages);

/** スラッグから言語データを取得 */
export function getLanguage(slug: string): LanguageData | undefined {
  return languages[slug];
}
